import React, { useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Label,
    Input,
    Container,
    Form,
    Spinner,
    Alert,
    Progress
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import axios from "axios";
import SDK from "../../../config";

const UploadGlassesApk = () => {
    const [formData, setFormData] = useState({
        versionName: "",
        versionCode: "",
        apkFile: null,
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0); // Track progress

    const validateField = (fieldName, value) => {
        let errorMsg = "";

        switch (fieldName) {
            case "versionName":
                errorMsg = value.trim() === "" ? "Version Name is required" : "";
                break;
            case "versionCode":
                errorMsg = value.trim() === "" ? "Version Code is required" : "";
                break;
            case "apkFile":
                errorMsg = !value ? "APK file is required" : "";
                break;
            default:
                break;
        }

        return errorMsg;
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "apkFile") {
            setFormData({ ...formData, [name]: files[0] });
            const errorMsg = validateField(name, files[0]);
            setErrors({ ...errors, [name]: errorMsg });
        } else {
            setFormData({ ...formData, [name]: value });
            const errorMsg = validateField(name, value);
            setErrors({ ...errors, [name]: errorMsg });
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files[0];
        if (file) {
            setFormData({ ...formData, apkFile: file });
            const errorMsg = validateField("apkFile", file);
            setErrors({ ...errors, apkFile: errorMsg });
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(false);
        const newErrors = {};
        Object.keys(formData).forEach((field) => {
            newErrors[field] = validateField(field, formData[field]);
        });

        setErrors(newErrors);
        const hasErrors = Object.values(newErrors).some((error) => error !== "");

        if (!hasErrors) {
            setIsSubmitting(true);
            setUploadProgress(0);

            try {
                const formDataToSubmit = new FormData();
                formDataToSubmit.append("versionName", formData.versionName);
                formDataToSubmit.append("versionCode", formData.versionCode);
                formDataToSubmit.append("apkFile", formData.apkFile);

                const response = await axios.post(
                    `${SDK.FRONTEND_DOMAIN}/post/apk/version`,
                    formDataToSubmit,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: (progressEvent) => {
                            if (progressEvent.total) {
                                const progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(progressPercentage);
                            }
                        },
                        timeout: 0,
                    }
                );

                if (response.status === 200) {
                    setSubmissionStatus({
                        success: true,
                        message: response.data.message || "APK uploaded successfully!",
                    });
                } else {
                    throw new Error(response.data.error || "Unexpected response from server");
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                setSubmissionStatus({ success: false, message: "Failed to upload APK. Please try again later." });
            } finally {
                setIsSubmitting(false);
            }
        } else {
            console.log("Form has errors:", newErrors);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content" style={{ minHeight: "100vh" }}>
                <Container fluid={true}>
                    <Breadcrumbs
                        title="Upload APK"
                        breadcrumbItems={[{ title: "Minimis" }, { title: "Upload APK" }]}
                    />
                    <Row className="d-flex justify-content-center align-content-center">
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    {submissionStatus && (
                                        <Alert color={submissionStatus.success ? "success" : "danger"}>
                                            {submissionStatus.message}
                                        </Alert>
                                    )}
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md="12">
                                                <div className="mb-3 position-relative">
                                                    <Label className="form-label" htmlFor="apkFile">
                                                        Upload APK File
                                                    </Label>

                                                    {/* Progress Bar */}
                                                    {isSubmitting && (
                                                        <div style={{ margin: "15px 0px" }}>
                                                            <Progress value={uploadProgress} />
                                                        </div>
                                                    )}
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            padding: "20px",
                                                            border: "2px dashed #ccc",
                                                            borderRadius: "10px",
                                                            textAlign: "center",
                                                            backgroundColor: "#f9f9f9",
                                                            cursor: "pointer",
                                                            transition: "background-color 0.3s ease",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column",
                                                        }}
                                                        onClick={() => document.getElementById("apkFile").click()}
                                                        onDrop={handleDrop}
                                                        onDragOver={handleDragOver}
                                                    >
                                                        <Input
                                                            type="file"
                                                            id="apkFile"
                                                            name="apkFile"
                                                            accept=".apk"
                                                            onChange={handleChange}
                                                            style={{ display: "none" }}
                                                        />
                                                        <div
                                                            style={{
                                                                fontSize: "24px",
                                                                color: "#333",
                                                                padding: "10px",
                                                            }}
                                                        >
                                                            <i
                                                                className="fa fa-cloud-upload-alt"
                                                                style={{
                                                                    fontSize: "40px",
                                                                    color: "#4955b3",
                                                                    transition: "transform 0.3s ease",
                                                                }}
                                                            ></i>
                                                            <p>Drag & Drop your APK here</p>
                                                            <small>or</small>
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize: "16px",
                                                                backgroundColor: "#4955b3",
                                                                color: "#fff",
                                                                padding: "10px 20px",
                                                                borderRadius: "5px",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                                transition: "background-color 0.3s ease",
                                                            }}
                                                        >
                                                            Choose file
                                                        </div>
                                                        {formData.apkFile && (
                                                            <div
                                                                style={{
                                                                    marginTop: "10px",
                                                                    fontWeight: "bold",
                                                                    color: "#007bff",
                                                                }}
                                                            >
                                                                <strong>{formData.apkFile.name}</strong>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {errors.apkFile && (
                                                        <div className="invalid-feedback d-block">
                                                            {errors.apkFile}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="mb-3 position-relative">
                                                    <Label className="form-label" htmlFor="versionName">
                                                        Version Name
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        id="versionName"
                                                        name="versionName"
                                                        value={formData.versionName}
                                                        placeholder="Enter Version Name (e.g., 1.1.1)"
                                                        onChange={handleChange}
                                                    />
                                                    {errors.versionName && (
                                                        <div className="invalid-feedback d-block">
                                                            {errors.versionName}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="mb-3 position-relative">
                                                    <Label className="form-label" htmlFor="versionCode">
                                                        Version Code
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        id="versionCode"
                                                        name="versionCode"
                                                        value={formData.versionCode}
                                                        placeholder="Enter Version Code (e.g., 2)"
                                                        onChange={handleChange}
                                                    />
                                                    {errors.versionCode && (
                                                        <div className="invalid-feedback d-block">
                                                            {errors.versionCode}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Button color="primary" type="submit" disabled={isSubmitting}>
                                            {isSubmitting ? <Spinner size="sm" /> : "Upload APK"}
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default UploadGlassesApk;
